import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaIndicacoes } from "./components/TabelaIndicacoes"

export function IndicacoesAmigos() {
    return (
        <>
            <Cabecalho pagina="Indicações de Amigos" />
            <TabelaIndicacoes />
        </>
    )
}
